import React, { Fragment } from "react";

import { makeStyles } from "@mui/styles";
import {
  Grid,
  DialogActions,
  DialogContent,
  Alert,
  Dialog,
  Box,
} from "@mui/material";
import { Close, CheckCircle, InsertLinkOutlined } from "@mui/icons-material";
import Moment from "moment";

import { cardBodyStyle, ButtonExit } from "components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function ViewLinkAdmin(props) {
  const classes = useStyles();

  let acceptTerms = props.id?.acceptTerms
    ? JSON.parse(props.id.acceptTerms)
    : null;
  let refunds = props.id?.refunds ? JSON.parse(props.id.refunds) : null;

  const handleCloseDialog = () => () => {
    props.exit();
  };

  const calculateDaysRemaining = (endDate) => {
    const today = Moment().startOf("day"); // Set to beginning of today
    const expirationDate = Moment(endDate).startOf("day"); // Set to beginning of end date
    const days = expirationDate.diff(today, "days");

    return days >= 1 ? days : 0; // Minimum 0 days (already expired)
  };

  const payment = props.id.paymentTransactions.filter(
    (transaction) => transaction.status === 1,
  );

  return (
    <Fragment>
      <Dialog
        fullWidth
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        maxWidth={"xs"}
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                <div className={classes.titleCardFilter}>
                  <InsertLinkOutlined /> Link de pago
                </div>
                <div className={classes.lineBottom}></div>
                <br></br>
              </Grid>
              <Grid item xs={12} md={12} sx={{ textAlign: "right" }}>
                <b style={{ fontSize: 12, color: "#000" }}>Creado:</b>{" "}
                <span style={{ fontWeight: 400 }}>
                  {Moment(props.id.createdAt).format("DD-MM-YYYY")}
                </span>
              </Grid>
              <Grid item xs={12} md={12}>
                <b style={{ fontSize: 12, color: "#000" }}>Cliente:</b>{" "}
                <span style={{ fontWeight: 400 }}>
                  {`${props.id.name} ${props.id.lastName}`}
                </span>
              </Grid>
              {props.id.documentId !== "123" && (
                <Grid item xs={12} md={12}>
                  <b style={{ fontSize: 12, color: "#000" }}>Documento:</b>{" "}
                  <span style={{ fontWeight: 400 }}>{props.id.documentId}</span>
                </Grid>
              )}
              <Grid item xs={12} md={12}>
                <b style={{ fontSize: 12, color: "#000" }}>Email:</b>{" "}
                <span style={{ fontWeight: 400 }}>{props.id.email}</span>
              </Grid>
              {props.id.phone !== "123" && (
                <Grid item xs={12} md={12}>
                  <b style={{ fontSize: 12 }}>Teléfono:</b>{" "}
                  <span style={{ fontWeight: 400 }}>{props.id.phone}</span>
                </Grid>
              )}
              <Grid item xs={12} md={12}>
                <b style={{ fontSize: 12 }}>Descripción:</b>{" "}
                <span style={{ fontWeight: 400 }}>{props.id.description}</span>
              </Grid>
              <Grid item xs={12} md={6} sx={{ mt: 1 }}>
                <b style={{ fontSize: 12 }}>Fecha inicio:</b>{" "}
                <span style={{ fontWeight: 400 }}>
                  {Moment(props.id.startExpiration).format("DD-MM-YYYY")}
                </span>
              </Grid>
              <Grid item xs={12} md={6} sx={{ mt: 1 }}>
                <b style={{ fontSize: 12 }}>Fecha fin:</b>{" "}
                <span style={{ fontWeight: 400 }}>
                  {Moment(props.id.endExpiration).format("DD-MM-YYYY")}
                </span>
              </Grid>
              <Grid item xs={12} md={12} sx={{ my: 1 }}>
                <b style={{ fontSize: 12 }}>Días de validez:</b>{" "}
                <span
                  style={{
                    fontWeight: "bold",
                    padding: "5px 10px",
                    background: "orange",
                    borderRadius: 20,
                  }}
                >
                  {calculateDaysRemaining(props.id.endExpiration)}
                </span>
              </Grid>

              {props.id.description === "PAGO POR API" && (
                <Grid item xs={12} md={12} sx={{ my: 1 }}>
                  <b style={{ fontSize: 12 }}>TRANSACCIÓN:</b>{" "}
                  <span
                    style={{
                      fontWeight: "bold",
                      padding: "5px 10px",
                      background: "rgb(255, 244, 229)",
                      borderRadius: 15,
                      fontSize: 10,
                    }}
                  >
                    {props.id.description}
                  </span>
                </Grid>
              )}
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  textAlign: "center",
                  p: 0.6,
                  m: 1,
                  background: "#F6F6F6",
                }}
              >
                <b style={{ fontSize: 12 }}>Valor a cobrar</b>
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  textAlign: "center",
                  py: 1,
                  borderBottom: "1px solid #ccc",
                }}
              >
                <span style={{ fontWeight: 500, fontSize: 14 }}>
                  {`SubTotal: $${props.id.description === "PAGO POR API" ? props.id.total : props.id.subTotal}`}
                </span>
              </Grid>
              {props.id.description !== "PAGO POR API" && (
                <Grid
                  item
                  xs={12}
                  md={12}
                  sx={{
                    textAlign: "center",
                    py: 1,
                    borderBottom: "1px solid #ccc",
                  }}
                >
                  <span style={{ fontWeight: 500, fontSize: 14 }}>
                    {`${parseFloat(props.id.iva).toFixed(0)}% iva: $${
                      props.id.ivaSubtotal
                    }`}
                  </span>
                </Grid>
              )}
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  textAlign: "center",
                  py: 1,
                  borderBottom: "1px solid #ccc",
                }}
              >
                <span style={{ fontWeight: 500, fontSize: 14, color: "red" }}>
                  {`Fee: - $${
                    props.id.commissionPayment
                      ? props.id.commissionPayment
                      : "0.00"
                  }`}
                </span>
              </Grid>
              <Grid item xs={12} md={12} sx={{ textAlign: "center", py: 1 }}>
                <span style={{ fontWeight: "bold", fontSize: 14 }}>
                  {`TOTAL: $${props.id.commissionPaymentTotal}`}
                </span>
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  textAlign: "center",
                  p: 0.6,
                  m: 1,
                  background: "#F6F6F6",
                }}
              >
                <b style={{ fontSize: 12 }}>ESTADO</b>
              </Grid>
              <Grid item xs={6} md={6} sx={{ textAlign: "center", px: 1 }}>
                <Alert
                  sx={{
                    fontSize: 10,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                  severity={props.id.acceptTerms ? "success" : "error"}
                  icon={false}
                >
                  TERMINOS Y CONDICIONES:<br></br>{" "}
                  {props.id.acceptTerms ? (
                    <>
                      <CheckCircle sx={{ color: "green" }} />
                      <Box sx={{ mt: 1 }}>Aceptado: {acceptTerms.date} </Box>
                    </>
                  ) : (
                    <Close sx={{ color: "red" }} />
                  )}
                </Alert>
              </Grid>
              <Grid item xs={6} md={6} sx={{ textAlign: "center", px: 1 }}>
                <Alert
                  sx={{
                    fontSize: 10,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                  severity={payment?.length > 0 ? "success" : "error"}
                  icon={false}
                >
                  {payment?.length > 0 ? (
                    <>
                      LINK UTILIZADO<br></br>{" "}
                      <CheckCircle sx={{ color: "green", mt: 1 }} />
                      <Box sx={{ mt: 1 }}>
                        Pago:{" "}
                        {Moment(payment[0]?.createdAt).format(
                          "DD-MM-YYYY HH:mm:ss",
                        )}
                      </Box>
                    </>
                  ) : (
                    <>
                      SIN TRANSACCIONES<br></br>{" "}
                      <Close sx={{ color: "red", mt: 2 }} />
                    </>
                  )}
                </Alert>
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  textAlign: "center",
                  px: 1,
                  mt: 1,
                  display: props.id?.status === 4 ? "block" : "none",
                }}
              >
                <Alert
                  sx={{
                    fontSize: 12,
                    fontWeight: "bold",
                  }}
                  severity={refunds?.admin ? "success" : "error"}
                  icon={false}
                >
                  SOLICITUD DE REEMBOLSO ENVIADA:{" "}
                  {Moment(refunds?.dateClient).format("DD-MM-YYYY")}
                  <br></br>{" "}
                  <Box
                    sx={{
                      fontSize: refunds?.admin ? 16 : 10,
                      ...(!refunds?.admin
                        ? {
                            mt: 1,
                            border: "1px solid red",
                            color: "rgb(102, 60, 0)",
                            background: "rgb(255, 244, 229)",
                            p: 1,
                            borderRadius: 3,
                          }
                        : {}),
                    }}
                  >
                    {refunds?.admin ? (
                      <b>
                        REEMBOLSO REALIZADO:{" "}
                        {Moment(refunds?.dateAdmin).format("DD-MM-YYYY")}
                      </b>
                    ) : (
                      "PENDIENTE POR REVISIÓN POR PARTE DE LA ADMINISTRACIÓN"
                    )}
                  </Box>
                </Alert>
              </Grid>
            </Grid>
          </Fragment>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
